import { render } from "./ShippingAddressFormCard.vue?vue&type=template&id=72102861&scoped=true&ts=true"
import script from "./ShippingAddressFormCard.vue?vue&type=script&lang=ts"
export * from "./ShippingAddressFormCard.vue?vue&type=script&lang=ts"

import "./ShippingAddressFormCard.vue?vue&type=style&index=0&id=72102861&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72102861"]])

export default __exports__